import { Doctor } from "@/types/schedule";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { DoctorSummaryCard } from "./DoctorSummaryCard";

interface DoctorSelectorProps {
  doctors: Doctor[];
  selectedDoctor: Doctor | null;
  onDoctorChange: (doctor: Doctor) => void;
}

export const DoctorSelector = ({
  doctors,
  selectedDoctor,
  onDoctorChange,
}: DoctorSelectorProps) => {
  return (
    <div className="sticky top-0 z-10 bg-background border-b shadow-sm">
      <div className="container mx-auto py-4 px-4 max-w-6xl">
        <div className="flex flex-col md:flex-row gap-4 items-start md:items-center">
          <div className="flex-1 min-w-[250px]">
            <Select
              value={selectedDoctor?.id || ""}
              onValueChange={(value) => {
                const doctor = doctors.find((d) => d.id === value);
                if (doctor) onDoctorChange(doctor);
              }}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Selecione um médico" />
              </SelectTrigger>
              <SelectContent>
                {doctors.map((doctor) => (
                  <SelectItem key={doctor.id} value={doctor.id}>
                    {doctor.name} - {doctor.specialty}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          {selectedDoctor && (
            <div className="flex-1">
              <DoctorSummaryCard doctor={selectedDoctor} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

